import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/footer/siteFooter/SiteFooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/MaintenanceBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/DatadogInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UtmCookieSetup"] */ "/app/apps/sb-shell/components/visitor-setup/UtmCookieSetup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/app/node_modules/.pnpm/@radix-ui+react-tooltip@1.2.8_@types+react-dom@19.2.3_@types+react@19.2.7__@types+react_61903d443f318e235810cb4023b9ffb4/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_babel-p_808d96c3bd2d3864059f0431583361bf/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/builder/clientUtils.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core-events/src/search/SearchEventEmitter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/app/packages/design-system/dist/index.es11.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toast","ToastProvider"] */ "/app/packages/design-system/dist/index.es14.js");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/app/packages/design-system/dist/index.es15.js");
;
import(/* webpackMode: "eager", webpackExports: ["RadioGroup"] */ "/app/packages/design-system/dist/index.es16.js");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogClose","DialogContent","DialogDescription","DialogFooter","DialogHeader","DialogOverlay","DialogPortal","DialogTitle","DialogTrigger"] */ "/app/packages/design-system/dist/index.es17.js");
;
import(/* webpackMode: "eager", webpackExports: ["TabsContent","TabsList","TabsRoot","TabsTrigger"] */ "/app/packages/design-system/dist/index.es19.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/packages/design-system/dist/index.es2.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContent","AccordionItem","AccordionRoot","AccordionTrigger"] */ "/app/packages/design-system/dist/index.es20.js");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/packages/design-system/dist/index.es21.js");
;
import(/* webpackMode: "eager", webpackExports: ["TextAreaInput"] */ "/app/packages/design-system/dist/index.es5.js");
;
import(/* webpackMode: "eager", webpackExports: ["RichText"] */ "/app/packages/design-system/dist/index.es6.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/packages/design-system/dist/index.es7.js");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleContent","CollapsibleRoot","CollapsibleTrigger"] */ "/app/packages/design-system/dist/index.es9.js");
